import React, { useEffect, useState } from 'react';
import Analytics from '../../components/Analytics';
import UsersByCountry from '../../components/UsersByCountry';
import SalesByTopCuisines from '../../components/SalesByTopCuisines';
import SalesByDeliveryType from '../../components/SalesByDeliveryType';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import SalesByPaymentType from '../../components/SalesByPaymentType';
import API from '../../utils/api';

const DashboardPage = ({ classes }) => {

  const [totalUsers, setTotalUsers] = useState(0)
  const [totalChefs, setTotalChefs] = useState(0)
  const [totalRestaurants, setTotalRestaurants] = useState(0)
  const [totalFoodItems, setTotalFoodItems] = useState(0)
  
  let initialValues = {
    daily: 0,
    weekly: 0,
    monthly: 0,
    yearly: 0,
    total: 0,
  }

  const [totalActiveOrders, setTotalActiveOrders] = useState(initialValues)
  const [totalInDeliveryOrders, setTotalInDeliveryOrders] = useState(initialValues)
  const [totalFinishedOrders, setTotalFinishedOrders] = useState(initialValues)
  const [totalCancelledOrders, setTotalCancelledOrders] = useState(initialValues)
  const [totalRejectedOrders, setTotalRejectedOrders] = useState(initialValues)

  const [totalDeliveredOrders, setTotalDeliveredOrders] = useState({
    self_pickup: 0,
    self_pickup_sales: 0,
    self_delivery: 0,
    self_delivery_sales: 0,
    ef_delivery: 0,
    ef_delivery_sales: 0,
    total_orders: 0,
    total_orders_sales: 0
  })

  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    getTotalUsers()
    getTotalChefs()
    getTotalRestaurants()
    getTotalFoodItems()

    getTotalActiveOrders()
    getTotalInDeliveryOrders()
    getTotalFinishedOrders()
    getTotalCancelledOrders()
    getTotalRejectedOrders()
    
    getTotalActiveOrders('daily')
    getTotalInDeliveryOrders('daily')
    getTotalFinishedOrders('daily')
    getTotalCancelledOrders('daily')
    getTotalRejectedOrders('daily')
    
    getDeliveredOrders('daily')

  }, [])

  const getTotalUsers = async () => {
    const totalUsersCount = await API.get(`/admin/dashboard/get-users-count`).then((response) => response).catch((error) => error);
    if (totalUsersCount && totalUsersCount.data && totalUsersCount?.data?.ResponseData?.totalUsers) {
      let target = totalUsersCount?.data?.ResponseData?.totalUsers;
      animateCount(target, setTotalUsers);
    }
  }

  const getTotalChefs = async () => {
    const totalChefsCount = await API.get(`/admin/dashboard/get-sellers-count?seller_type=Chef`).then((response) => response).catch((error) => error);
    if (totalChefsCount && totalChefsCount.data && totalChefsCount?.data?.ResponseData?.totalSellers) {
      let target = totalChefsCount?.data?.ResponseData?.totalSellers;
      animateCount(target, setTotalChefs);
    }
  }

  const getTotalRestaurants = async () => {
    const totalRestaurantsCount = await API.get(`/admin/dashboard/get-sellers-count?seller_type=Restaurant`).then((response) => response).catch((error) => error);
    if (totalRestaurantsCount && totalRestaurantsCount.data && totalRestaurantsCount?.data?.ResponseData?.totalSellers) {
      let target = totalRestaurantsCount?.data?.ResponseData?.totalSellers;
      animateCount(target, setTotalRestaurants);
    }
  }

  const getTotalFoodItems = async () => {
    const totalFoodItemsCount = await API.get(`/admin/dashboard/get-items-count`).then((response) => response).catch((error) => error);
    if (totalFoodItemsCount && totalFoodItemsCount.data && totalFoodItemsCount?.data?.ResponseData?.totalFoodItems) {
      let target = totalFoodItemsCount?.data?.ResponseData?.totalFoodItems;
      animateCount(target, setTotalFoodItems);
    }
  }

  const getTotalActiveOrders = async (order_type = 'total') => {
    const totalActiveOrdersCount = await API.get(`/admin/dashboard/get-orders-count?order_type=${order_type}&status=active`).then((response) => response).catch((error) => error);
    if (totalActiveOrdersCount && totalActiveOrdersCount.data && totalActiveOrdersCount?.data?.ResponseData?.total_orders) {
      let target = totalActiveOrdersCount?.data?.ResponseData?.total_orders;
      animateCount(target, setTotalActiveOrders, order_type);
    }
  }

  const getTotalInDeliveryOrders = async (order_type = 'total') => {
    const totalInDeliveryOrdersCount = await API.get(`/admin/dashboard/get-orders-count?order_type=${order_type}&status=in_delivery`).then((response) => response).catch((error) => error);
    if (totalInDeliveryOrdersCount && totalInDeliveryOrdersCount.data && totalInDeliveryOrdersCount?.data?.ResponseData?.total_orders) {
      let target = totalInDeliveryOrdersCount?.data?.ResponseData?.total_orders;
      animateCount(target, setTotalInDeliveryOrders, order_type);
    }
  }

  const getTotalFinishedOrders = async (order_type = 'total') => {
    const totalFinishedOrdersCount = await API.get(`/admin/dashboard/get-orders-count?order_type=${order_type}&status=finished`).then((response) => response).catch((error) => error);
    if (totalFinishedOrdersCount && totalFinishedOrdersCount.data && totalFinishedOrdersCount?.data?.ResponseData?.total_orders) {
      let target = totalFinishedOrdersCount?.data?.ResponseData?.total_orders;
      animateCount(target, setTotalFinishedOrders, order_type);
    }
  }

  const getTotalCancelledOrders = async (order_type = 'total') => {
    const totalCancelledOrdersCount = await API.get(`/admin/dashboard/get-orders-count?order_type=${order_type}&status=cancelled`).then((response) => response).catch((error) => error);
    if (totalCancelledOrdersCount && totalCancelledOrdersCount.data && totalCancelledOrdersCount?.data?.ResponseData?.total_orders) {
      let target = totalCancelledOrdersCount?.data?.ResponseData?.total_orders;
      animateCount(target, setTotalCancelledOrders, order_type);
    }
  }

  const getTotalRejectedOrders = async (order_type = 'total') => {
    const totalRejectedOrdersCount = await API.get(`/admin/dashboard/get-orders-count?order_type=${order_type}&status=rejected`).then((response) => response).catch((error) => error);
    if (totalRejectedOrdersCount && totalRejectedOrdersCount.data && totalRejectedOrdersCount?.data?.ResponseData?.total_orders) {
      let target = totalRejectedOrdersCount?.data?.ResponseData?.total_orders;
      animateCount(target, setTotalRejectedOrders, order_type);
    }
  }

  const getDeliveredOrders = async (order_type = 'total') => {
    const totalRejectedOrdersCount = await API.get(`/admin/dashboard/get-orders-count?order_type=${order_type}&status=finished&group_by=delivery_option`).then((response) => response).catch((error) => error);
    if (totalRejectedOrdersCount && totalRejectedOrdersCount.data && totalRejectedOrdersCount?.data?.ResponseData?.total_orders) {
      let data = totalRejectedOrdersCount?.data?.ResponseData;
      setTotalDeliveredOrders({
        self_pickup: data.self_pickup,
        self_delivery: data.self_delivery,
        ef_delivery: data.ef_delivery,
        total_orders: data.total_orders,

        self_pickup_sales: data.self_pickup_sales,
        self_delivery_sales: data.self_delivery_sales,
        ef_delivery_sales: data.ef_delivery_sales,
        total_orders_sales: data.total_orders_sales,
      })
    }
  }


  const animateCount = (target, setValue, order_type) => {
    let start = 0;
    setIsUpdating(true); // Indicate that the count is updating
    const step = () => {
      start += Math.ceil(target / 100); // Adjust step size for speed of animation
      if (start >= target) {
        if(order_type){
          setValue((prev) => ({
            ...prev, 
            [order_type]: target,
          }));
        }else{
          setValue(target);
        }
        setIsUpdating(false); // End the update
      } else {

        if(order_type){
          setValue((prev) => ({
            ...prev, 
            [order_type]: start,
          }));
        }else{
          setValue(start);
        }
        // setValue(start);
        requestAnimationFrame(step); // Keep calling step to animate the number
      }
    };
    requestAnimationFrame(step); // Start the animation
  };


  return (
    <div className={classes.wrap}>

      <div className={classes.section1}>
        <div className={classes.statistics}>

          <Card className={`${classes.root} w-100 `}>
            <div className="live-pulse-effect">
              <CardHeader subheader="Daily Order Status" classes={{ subheader: classes.header }} />
              <div className="circle pulse pulse-effect-red"></div>
            </div>

            <CardContent className={`flex flex-wrap justify-content-between ${classes.statisticRoot}`}>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#f58634' }}> <strong>{totalActiveOrders?.daily || 0}</strong> </label>
                <label> Active Orders </label>
              </div>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#1890ff' }}> <strong>{totalInDeliveryOrders?.daily || 0}</strong> </label>
                <label> In Delivery </label>
              </div>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#6baf30' }}> <strong>{totalFinishedOrders?.daily || 0}</strong> </label>
                <label> Finished Orders</label>
              </div>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#000' }}> <strong>{totalCancelledOrders?.daily || 0}</strong> </label>
                <label> Cancelled</label>
              </div>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#000' }}> <strong>{totalRejectedOrders?.daily || 0}</strong> </label>
                <label> Rej / Exp</label>
              </div>
              <div className={{}} style={{
                width: classes.item.width,
                flexDirection: classes.item.flexDirection
              }}>
              </div>
            </CardContent>
          </Card>

          <Card className={`${classes.root} w-100 `}>
            <CardHeader subheader="Total Orders" classes={{ subheader: classes.header }} />
            <CardContent className={`flex flex-wrap justify-content-between ${classes.statisticRoot}`}>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#f58634' }}> <strong>{totalActiveOrders?.total || 0}</strong> </label>
                <label> Active Orders </label>
              </div>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#6baf30' }}> <strong>{totalFinishedOrders?.total || 0}</strong> </label>
                <label> Finished Orders</label>
              </div>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#000' }}> <strong>{totalCancelledOrders?.total || 0}</strong> </label>
                <label> Cancelled</label>
              </div>
              <div className={classes.item}>
                <label className={classes.value} style={{ color: '#000' }}> <strong>{totalRejectedOrders?.total || 0}</strong> </label>
                <label> Rej / Exp</label>
              </div>
            </CardContent>
          </Card>
          
          <Card className={`${classes.root} w-100 `}>
            <CardHeader subheader="Statistics" classes={{ subheader: classes.header }} />
            <CardContent className={`flex flex-wrap justify-content-between ${classes.statisticRoot}`}>
              <div className={classes.item}>
                <label className={classes.value}> <strong>{totalUsers}</strong> </label>
                <label> Total Users </label>
              </div>
              <div className={classes.item}>
                <label className={classes.value}> <strong>{totalChefs}</strong> </label>
                <label> Total Chefs </label>
              </div>
              <div className={classes.item}>
                <label className={classes.value}> <strong>{totalRestaurants}</strong> </label>
                <label> Total Restaurants </label>
              </div>
              <div className={classes.item}>
                <label className={classes.value}> <strong>{totalFoodItems}</strong> </label>
                <label> Total Food Items </label>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className={classes.salesByDeliveryType}>
          <SalesByDeliveryType data={totalDeliveredOrders}/>
        </div>

      </div>

      {/* <div className={classes.analytics}>
        <Card className={`${classes.root} ${classes.analysis} w-100 `}>
          <CardHeader subheader="User Analysis" classes={{ subheader: classes.header }} />
          <CardContent className={`flex flex-wrap justify-content-between ${classes.statisticRoot}`}>
            <Analytics width={'40%'} />
          </CardContent>
        </Card>
      </div> */}

      {/* 
      <div className={classes.section2}>
        <div className={classes.usersByCountry}>
          <UsersByCountry />
        </div>
        <div className={classes.usersByCountry}>
          <SalesByTopCuisines />
        </div>
      </div> */}


      {/* <div className={classes.section3}>
        <div className={classes.sales}>
          <SalesByPaymentType />
        </div>
      </div> */}

    </div>
  );
};

export default DashboardPage;
